export function arrayToDictionary<T>(
  arr: T[],
  keySelector: (el: T) => string
): Map<string, T> {
  return arr.reduce((map, item) => {
    const key = keySelector(item);
    map.set(key, item);
    return map;
  }, new Map());
}
